import { IAppState } from "../../../app/appTypes"
import { ICasePathway, IHaveCasePathwayId } from "../../../features/casePathways/state/casePathwayTypes"

export const getCasePathwayById = (ownProps: IHaveCasePathwayId) => (state: IAppState): ICasePathway =>
  state.entities.casePathways.byId[ownProps.casePathwayId]
